// Helper function to sanitize params by removing < and > characters
// can be removed after moving to @fiverr-private/i18n-react + removing dangerouslySetInnerHTML
export const sanitizeParams = (params: unknown) => {
    if (!params || typeof params !== 'object') {
        return params;
    }

    const sanitized = {};
    for (const [key, value] of Object.entries(params)) {
        if (typeof value === 'string') {
            sanitized[key] = value.replace(/[<>]/g, '');
        } else {
            sanitized[key] = value;
        }
    }
    return sanitized;
};
